import React from "react";
import { useI18n } from "../context/I18nContext";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang, languages } = useI18n();
  return (
    <div
      data-testid="language-switcher"
      className={`flex items-center ${compact ? "gap-1" : "gap-2"} text-xs`}
    >
      {!compact && <Globe className="w-3.5 h-3.5 text-gray-500" />}
      {languages.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          data-testid={`lang-${l.code}`}
          className={`px-2 py-1 font-chivo font-bold tracking-[0.15em] uppercase transition-colors ${
            lang === l.code
              ? "text-[#082c50] underline underline-offset-4"
              : "text-gray-500 hover:text-[#082c50]"
          }`}
          aria-label={l.name}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
